import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText } from "lucide-react";

export const STATUS_STYLE = {
  "Draf": "bg-slate-100 text-slate-700",
  "Menunggu Persetujuan": "bg-amber-100 text-amber-800",
  "Disetujui": "bg-emerald-100 text-emerald-800",
  "Ditolak": "bg-rose-100 text-rose-700",
};

export const NotaStatus = ({ s, testid }) => (
  <span className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-bold ${STATUS_STYLE[s] || ""}`} data-testid={testid}>{s}</span>
);

export function useBlobUrl(path) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u = null;
    if (!path) return undefined;
    api.get(`/nota-pengajuan-file/${path}`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => setUrl(""));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [path]);
  return url;
}

export const Lampiran = ({ f, onOpen, onRemove, testid }) => {
  const url = useBlobUrl(f.path);
  const isPdf = f.content_type === "application/pdf";
  return (
    <div className="relative w-24" data-testid={testid}>
      <button type="button" onClick={() => url && onOpen({ url, isPdf, nama: f.nama_file })}
        className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-lg border border-slate-200 bg-slate-50 hover:ring-2 hover:ring-orange-400">
        {isPdf ? <FileText className="h-8 w-8 text-rose-600" /> : url ? <img src={url} alt={f.nama_file} className="h-full w-full object-cover" /> : <span className="text-xs text-slate-400">memuat…</span>}
      </button>
      <div className="mt-1 truncate text-[10px] text-slate-500">{f.nama_file}</div>
      {onRemove && <button type="button" onClick={onRemove} className="absolute -right-1.5 -top-1.5 h-5 w-5 rounded-full bg-rose-600 text-xs font-bold text-white" data-testid={`${testid}-remove`}>×</button>}
    </div>
  );
};
